import {GENERATE_PROMOCODE} from '../actions/const';

const initialState = {
  couponCode: '',
  merchant: null,
  user: '',
  prefix: '',
  numberOfCodes: '1',
  length: '8',
  isExclusive: null
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case GENERATE_PROMOCODE:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/GeneratePromocode.js